import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/common/Footer';
import Logo from '../components/common/Logo';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const Terms = () => {
  // console.log('Mounting Terms');

  return (
    <motion.div
      className="min-h-screen bg-gray-900 flex flex-col"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <header className="border-b border-gray-800 py-4 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link 
            to="/" 
            className="flex items-center text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeftIcon className="w-5 h-5 mr-2" />
            <span>Back</span>
          </Link>
          <div className="flex justify-center">
            <Logo size="small" />
          </div>
          <div className="w-20"></div> {/* Empty div for spacing */}
        </div>
      </header>
      
      <div className="flex-grow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
          <h1 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8">Terms of Service</h1>
          
          <div className="prose prose-sm sm:prose-base lg:prose-lg prose-invert max-w-none">
            <p className="text-lg text-gray-300 mb-8">
              Welcome to Open Org's Content Hub. By accessing or using our service, you agree to be bound by these Terms of Service.
            </p>
            
            <h2>1. Account Registration</h2>
            <p>
              To access premium features, you must register for an account and provide accurate information. You are responsible for maintaining the confidentiality of your account credentials.
            </p>
            
            <h2>2. Subscription Services</h2>
            <p>
              Open Org's Content Hub offers subscription-based access to resources, templates, and discounts. By purchasing a subscription, you agree to the following:
            </p>
            <ul>
              <li>Payment of the subscription fee according to the plan you select</li>
              <li>Automatic renewal of your subscription unless canceled in advance</li>
              <li>Subscription fees are non-refundable except where required by law</li>
            </ul>
            
            <h2>3. User Accounts</h2>
            <p>
              When you create an account with us, you must provide accurate, complete, and up-to-date information. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.
            </p>
            
            <h2>4. Intellectual Property</h2>
            <p>
              All content available through our Service, including but not limited to text, graphics, logos, icons, images, audio clips, digital downloads, and data compilations, is the property of Open Org Group Ltd or its content suppliers and protected by international copyright laws.
            </p>
            
            <h2>5. Prohibited Uses</h2>
            <p>
              You may use our Service only for lawful purposes and in accordance with these Terms. You agree not to:
            </p>
            <ul>
              <li>Use the Service in any way that violates any applicable law or regulation</li>
              <li>Share your account credentials with others or allow others to access your account</li>
              <li>Attempt to access restricted areas of the Service without authorization</li>
              <li>Engage in any conduct that restricts or inhibits anyone's use or enjoyment of the Service</li>
            </ul>
            
            <h2>6. Limitation of Liability</h2>
            <p>
              In no event shall Open Org Group Ltd, its officers, directors, employees, or agents, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, or use, arising out of or in any way connected with the use of or inability to use the Service.
            </p>
            
            <h2>7. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will provide notice of significant changes by updating the date at the top of these Terms and you waive any right to receive specific notice of each such change.
            </p>
            
            <h2>8. Contact Information</h2>
            <p>
              If you have any questions about these Terms, please contact us at support@openorg.fyi.
            </p>
            
            <p className="text-sm text-gray-500 mt-8">
              Last updated: May 1, 2025
            </p>
          </div>
        </div>
      </div>
      
      <Footer />
    </motion.div>
  );
};

export default Terms; 